import { useEffect, useState } from 'react';
import { debounce } from '@repo/shared';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const updateDebouncedValue = debounce((nextValue: T) => {
      setDebouncedValue(nextValue);
    }, delay);

    updateDebouncedValue(value);

    return () => {
      updateDebouncedValue.cancel();
    };
  }, [delay, value]);

  return debouncedValue;
}
